import React from 'react';

const ImagePreview = ({ url, altText }) => {
  return (
    <div className="image-preview">
      {url ? (
        <img src={url} alt={altText} />
      ) : (
        <div className="placeholder">
          {altText}
        </div>
      )}
    </div>
  );
};

export default ImagePreview;